'use strict';

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var PeerId = require('peer-id');

var _require = require('multiaddr'),
    Multiaddr = _require.Multiaddr;

var _require2 = require('libp2p-record'),
    Record = _require2.Record;

var Proto = require('./dht');

var MESSAGE_TYPE = Proto.Message.MessageType;
var CONNECTION_TYPE = Proto.Message.ConnectionType;
/**
 * @typedef {0|1|2|3|4} ConnectionType
 *
 * @typedef {object} PBPeer
 * @property {Uint8Array} id
 * @property {Uint8Array[]} addrs
 * @property {ConnectionType} connection
 *
 * @typedef {import('../index').PeerData} PeerData
 */

/**
 * Represents a single DHT control message.
 */

var Message = /*#__PURE__*/function () {
  /**
   * @param {import('./dht').Message.MessageType} type
   * @param {Uint8Array} key
   * @param {number} level
   */
  function Message(type, key, level) {
    _classCallCheck(this, Message);

    if (key && !(key instanceof Uint8Array)) {
      throw new Error('Key must be a Uint8Array');
    }

    this.type = type;
    this.key = key;
    this._clusterLevelRaw = level;
    /** @type {PeerData[]} */

    this.closerPeers = [];
    /** @type {PeerData[]} */

    this.providerPeers = [];
    /** @type {import('libp2p-record').Record | undefined} */

    this.record = undefined;
  }
  /**
   * @type {number}
   */


  _createClass(Message, [{
    key: "clusterLevel",
    get: function get() {
      var level = this._clusterLevelRaw - 1;

      if (level < 0) {
        return 0;
      }

      return level;
    },
    set: function set(level) {
      this._clusterLevelRaw = level;
    }
    /**
     * Encode into protobuf
     */

  }, {
    key: "serialize",
    value: function serialize() {
      var obj = {
        key: this.key,
        type: this.type,
        clusterLevelRaw: this._clusterLevelRaw,
        closerPeers: this.closerPeers.map(toPbPeer),
        providerPeers: this.providerPeers.map(toPbPeer),

        /** @type {Uint8Array | undefined} */
        record: undefined
      };

      if (this.record) {
        if (this.record instanceof Uint8Array) {
          obj.record = this.record;
        } else {
          obj.record = this.record.serialize();
        }
      }

      return Proto.Message.encode(obj).finish();
    }
    /**
     * Decode from protobuf
     *
     * @param {Uint8Array} raw
     */

  }], [{
    key: "deserialize",
    value: function deserialize(raw) {
      var dec = Proto.Message.decode(raw);
      var msg = new Message(dec.type || 0, dec.key || Uint8Array.from([]), dec.clusterLevelRaw || 0);
      msg.closerPeers = dec.closerPeers.map(fromPbPeer);
      msg.providerPeers = dec.providerPeers.map(fromPbPeer);

      if (dec.record && dec.record.length) {
        msg.record = Record.deserialize(dec.record);
      }

      return msg;
    }
  }]);

  return Message;
}();

Message.TYPES = MESSAGE_TYPE;
Message.CONNECTION_TYPES = CONNECTION_TYPE;
/**
 * @param {PeerData} peer
 */

function toPbPeer(peer) {
  /** @type {PBPeer} */
  var output = {
    id: peer.id.id,
    addrs: (peer.multiaddrs || []).map(function (m) {
      return m.bytes;
    }),
    connection: CONNECTION_TYPE.CONNECTED
  };
  return output;
}
/**
 * @param {import('./dht').Message.IPeer} peer
 */


function fromPbPeer(peer) {
  return {
    // @ts-ignore id is optional on protobuf, but it will exist?
    id: new PeerId(peer.id),
    multiaddrs: (peer.addrs || []).map(function (a) {
      return new Multiaddr(a);
    })
  };
}

module.exports = Message;